module.exports = __webpack_public_path__ + "img/traffic2.76324229.png";